import React from 'react';

export function useControlledUncontrolledState<T = unknown>(config: {
  defaultState: T;
  controlledState?: T;
  onChange?: (newState: T) => void;
}): [T, (newVal: T) => void] {
  const { defaultState, controlledState, onChange } = config;
  const [state, setState] = React.useState<T>(defaultState);
  // due to javascript "falsy" crazy bonanza,
  //  we are gonna use Object.hasOwnProperty to check if controlledState should be used
  //   this covers scenarios such as `controlledState=undefined`/`controlledState=null`/`controlledState=false`/`controlledState=0`/`controlledState=''`
  //   where we want to use the controlledState but we want the value to be the falsy value itself...
  const shouldUseControlledState = Object.hasOwnProperty.call(config, 'controlledState');
  const finalState = React.useMemo(() => {
    if (shouldUseControlledState) return controlledState as T;
    return state;
  }, [shouldUseControlledState, controlledState, state]);
  const finalSetState = React.useCallback(
    (newVal: T) => {
      setState(newVal);
      if (onChange) onChange(newVal);
    },
    [onChange],
  );
  return [finalState, finalSetState];
}
